// extracted by mini-css-extract-plugin
var _1 = "background-oZMAa";
var _2 = "handle-ayUnE";
var _3 = "switch-FNXRE";
export { _1 as "background", _2 as "handle", _3 as "switch" }
